export var TemplatePanel;
(function (TemplatePanel) {
    TemplatePanel["All_flows"] = "All_flows";
    TemplatePanel["Starred"] = "Starred";
    TemplatePanel["My_flows"] = "My_flows";
    TemplatePanel["Shared"] = "Shared";
    TemplatePanel["Lead_forms"] = "Lead_forms";
})(TemplatePanel || (TemplatePanel = {}));
// Template file is for non-flow templates
export var FileTemplatePanel;
(function (FileTemplatePanel) {
    FileTemplatePanel["Emails"] = "Emails";
    FileTemplatePanel["Packages"] = "Packages";
    FileTemplatePanel["Contact_forms"] = "Contact_forms";
    FileTemplatePanel["Gift_cards"] = "Gift_cards";
    FileTemplatePanel["Email_signature"] = "Email_signature";
    FileTemplatePanel["Brochures"] = "Brochures";
    FileTemplatePanel["Invoices"] = "Invoices";
    FileTemplatePanel["Proposals"] = "Proposals";
    FileTemplatePanel["Questionnaires"] = "Questionnaires";
    FileTemplatePanel["Agreements"] = "Agreements";
    FileTemplatePanel["Blocks"] = "Blocks";
    FileTemplatePanel["All"] = "All";
})(FileTemplatePanel || (FileTemplatePanel = {}));
export const TemplateTypes = {
    EMAIL: 'Email',
    PACKAGE: 'Package',
    CONTACT_FORM: 'Contact form',
    GIFT_CARD: 'Gift card',
    EMAIL_SIGNATURE: 'Email signature',
    BROCHURE: 'Brochure',
    FLOW: 'Flow',
    CONTRACT: 'Contract',
    INVOICE: 'Invoice',
    QUESTIONNAIRE: 'Questionnaire',
    PROPOSAL: 'Proposal',
    BLOCK: 'Block'
};
export const TemplateViewModelNames = {
    EMAIL: 'email',
    PACKAGE: 'package',
    CONTACT_FORM: 'contact form',
    GIFT_CARD: 'gift card',
    EMAIL_SIGNATURE: 'email signature',
    BROCHURE: 'brochure',
    FLOW: 'Flow',
    INVOICE: 'invoice',
    QUESTIONNAIRE: 'questionnaire',
    PROPOSAL: 'proposal',
    AGREEMENT: 'agreement',
    TIMELINE: 'timeline'
};
export const TemplateViewModelKeys = {
    EMAIL: 'email',
    PACKAGE: 'package',
    CONTACT_FORM: 'contactForm',
    GIFT_CARD: 'giftCard',
    EMAIL_SIGNATURE: 'emailSignature',
    BROCHURE: 'brochure',
    FLOW: 'flow',
    INVOICE: 'invoice',
    QUESTIONNAIRE: 'questionnaire',
    PROPOSAL: 'proposal',
    AGREEMENT: 'agreement',
    TIMELINE: 'timeline'
};
// If one of the types here changed, change also on
// template_repository_manager.rb - delete_blocks_from_template_for_custom_option
export var CreateTemplateType;
(function (CreateTemplateType) {
    CreateTemplateType["Brochures"] = "Brochures";
    CreateTemplateType["Contact_forms"] = "Contact_forms";
    CreateTemplateType["ContentApproval"] = "ContentApproval";
    CreateTemplateType["Contract"] = "Contract";
    CreateTemplateType["Custom"] = "Custom";
    CreateTemplateType["Emails"] = "Emails";
    CreateTemplateType["Gift_cards"] = "Gift_cards";
    CreateTemplateType["Invoice"] = "Invoice";
    CreateTemplateType["RecurringInvoice"] = "RecurringInvoice";
    CreateTemplateType["MoodBoard"] = "MoodBoard";
    CreateTemplateType["Packages"] = "Packages";
    CreateTemplateType["Proposal"] = "Proposal";
    CreateTemplateType["Questionnaire"] = "Questionnaire";
    CreateTemplateType["Scheduler"] = "Scheduler";
    CreateTemplateType["Lead_form"] = "Lead_form";
    CreateTemplateType["TestimonialRequest"] = "Testimonial";
    CreateTemplateType["LegacyInvoice"] = "LegacyInvoice";
    CreateTemplateType["LegacyContract"] = "LegacyContract";
    CreateTemplateType["LegacyProposal"] = "LegacyProposal";
    CreateTemplateType["LegacyQuestionnaire"] = "LegacyQuestionnaire";
    CreateTemplateType["LegacyBrochure"] = "LegacyBrochure";
    CreateTemplateType["Blocks"] = "Blocks";
})(CreateTemplateType || (CreateTemplateType = {}));
/* these flow templates ids are being used for flip to flow */
export var CreateTemplateIds;
(function (CreateTemplateIds) {
    CreateTemplateIds["Contract"] = "60e6efe95366840059b4867c";
    CreateTemplateIds["Invoice"] = "60eadfc9657fff00817abed2";
    CreateTemplateIds["BlankInvoice"] = "6396060c49d9ab002fe2c909";
    CreateTemplateIds["RecurringInvoice"] = "62e0f30427f7bd00339285b3";
    CreateTemplateIds["Proposal"] = "60eae1f7657fff00b7b2d63d";
    CreateTemplateIds["ProposalRecurringInvoice"] = "62e0f30b35259b002c328064";
    CreateTemplateIds["Questionnaire"] = "60eae3f4657fff00eaf6f914";
    CreateTemplateIds["Brochures"] = "615c5f6f77cb540073404faf";
    CreateTemplateIds["SessionSelection"] = "65bf79f3177f6e00254948fd";
    CreateTemplateIds["MoodBoard"] = "62f8b439d31353002de2e09a";
    CreateTemplateIds["Testimonial"] = "62f8b4410ad51a00fcceffd2";
    CreateTemplateIds["ContentApproval"] = "62f8b448fc097a002d554eda";
    CreateTemplateIds["Custom"] = "62f8b42e60297f01094cd2e2";
    CreateTemplateIds["Scheduler"] = "6371ff42fff9a5002ccc1035";
})(CreateTemplateIds || (CreateTemplateIds = {}));
export var CreateLeadFormTemplateIds;
(function (CreateLeadFormTemplateIds) {
    CreateLeadFormTemplateIds["Services"] = "6476176ac48b39002dff9130";
    CreateLeadFormTemplateIds["Scheduler"] = "64761748a63b3d002d27b425";
    CreateLeadFormTemplateIds["Invoice"] = "6476178115704504e17b82d1";
    CreateLeadFormTemplateIds["Contract"] = "6a301297502c2e990a5e8c94";
})(CreateLeadFormTemplateIds || (CreateLeadFormTemplateIds = {}));
export const FOLDERS_UI_PERSISTENCE_KEY = 'selectedTemplatePanel';
export const MY_TEMPLATES_LAYOUT_VIEW_MODE = 'myTemplatesLayoutViewMode';
export const IS_VISIT_IN_MY_TEMPLATES = 'isVisitInMyTemplates';
export const MEMBER_TEMPLATE_SHARING = 'member_template_sharing';
export const GALLERY_TEMPLATE = 'template_gallery';
export const TEMPLATE_SELLING = 'template_selling';
export const PRICED_TEMPLATE_OBJECT_TYPE = 'priced';
export const FREE_TEMPLATE_OBJECT_TYPE = 'free';
export const LEGACY_TEMPLATES_UI_PERSISTENCE_DEFAULT_VALUE = {
    filterKey: FileTemplatePanel.Invoices,
    sortKey: '-created_at',
    viewKey: 'card'
};
//# sourceMappingURL=templates.types.js.map